import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@linaria/react';
import { ReviewCarousel } from 'components/Reviews/ReviewCarousel';
import { showGuestReviewsOverlay } from 'modules/overlay/actions';
import { Button } from '@daedalus/atlas/Button';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { Review } from '@findhotel/sapi';
import { SelectedElementType } from '../DateGuestInput/ReviewsTrackClick';
interface Props {
  reviewsData: Review[];
}
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wmopn76",
  propsAsIs: false
});
export const ReviewCarouselSection: React.FC<Props> = ({
  reviewsData
}) => {
  const dispatch = useDispatch();
  const handleReadAllReviews = useCallback(() => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.ReviewDetails,
      action: Action.Clicked,
      payload: {
        selectedElement: SelectedElementType.ReviewCard
      }
    }));
    dispatch(showGuestReviewsOverlay());
  }, [dispatch]);
  const shouldShowAllReviewsSection = Boolean(reviewsData?.length);
  const firstSixReviews = reviewsData?.slice(0, 6);
  return shouldShowAllReviewsSection ? <Wrapper>
      <ReviewCarousel reviews={firstSixReviews} handleReadMoreClick={handleReadAllReviews} />
      <Button variant="secondary" fullWidth size="xl" onClick={handleReadAllReviews}>
        <FormattedMessageWrapper id="readAllReviews" defaultMessage="Read all reviews" />
      </Button>
    </Wrapper> : null;
};

require("./ReviewCarouselSection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewCarouselSection.tsx");